import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Select } from 'antd';
const { Option } = Select;

const BranchSelection = ({ show, onHide, onSelectBranch, initialBranch = null }) => {
    const [branches, setBranches] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(initialBranch?.id || '');

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await fetch("https://live.jeyaagency.com/api/global/branch/list?");
                const data = await response.json();
                setBranches(data.branches);
            } catch (error) {
                console.error('Error fetching branches:', error);
            }
        };

        fetchBranches();
    }, []);

    useEffect(() => {
        if (initialBranch) {
            setSelectedBranchId(initialBranch.id);
        }
    }, [initialBranch]);

    const handleBranchSelect = () => {
        if (!selectedBranchId) {
            // Ant Design Form validation will handle this
            return;
        }
        const selectedBranch = branches.find(b => String(b.id) === String(selectedBranchId));
        if (!selectedBranch) return;
        const branchData = {
            id: selectedBranch.id,
            branch: selectedBranch.branch
        };
        localStorage.setItem('selectedBranch', JSON.stringify(branchData));
        if (localStorage.getItem('userToken')) {
            localStorage.setItem('userBranch', JSON.stringify(branchData));
        }
        onSelectBranch(branchData);
        if (onHide) onHide();
    };

    return (
        <Modal
            open={show}
            onCancel={onHide}
            footer={null}
            title="Select Branch"
            centered
            maskClosable={false}
            destroyOnHidden
        >
            <Form
                layout="vertical"
                onFinish={handleBranchSelect}
                initialValues={{ branch: selectedBranchId }}
            >
                <Form.Item
                    label="Branch"
                    name="branch"
                    rules={[{ required: true, message: 'Please select a branch to continue' }]}
                >
                    <Select
                        placeholder="Select a branch"
                        value={selectedBranchId}
                        onChange={value => setSelectedBranchId(value)}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {branches.map(branch => (
                            <Option key={branch.id} value={branch.id}>
                                {branch.branch}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        block
                        disabled={!selectedBranchId}
                    >
                        Select Branch
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default BranchSelection;
